/**
 * pages/NotFound.tsx
 * 404 page — shown for any unmatched route.
 */

import React from 'react';
import { Search, ArrowLeft } from 'lucide-react';

const C = { amber100:'#FFF4E0', amber200:'#FFD88A', amber300:'#F5A623', amber400:'#C4811A', amber500:'#8B5A0A', ink:'#1A1814', muted:'#7A7570', border:'#E8E4DC', surface:'#FAFAF8', white:'#FFFFFF' };
const font = { head:"'Sora',sans-serif", body:"'DM Sans',sans-serif" };

const NotFound: React.FC = () => (
  <>
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Sora:wght@700;800&family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600&display=swap');
      *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
      body{font-family:'DM Sans',sans-serif;background:${C.surface};color:${C.ink};}
    `}</style>
    <div style={{ minHeight:'100vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:24, background:`linear-gradient(160deg,#FFFDF8 60%,#FFF6E0 100%)` }}>
      {/* Logo */}
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:48 }}>
        <div style={{ width:36, height:36, borderRadius:11, background:`linear-gradient(145deg,${C.amber200},${C.amber400})`, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <Search size={16} color={C.white}/>
        </div>
        <span style={{ fontFamily:font.head, fontWeight:800, fontSize:20, letterSpacing:'-0.05em', color:C.ink }}>Jötr</span>
      </div>

      {/* 404 */}
      <div style={{ textAlign:'center', maxWidth:440 }}>
        <div style={{ fontFamily:font.head, fontWeight:800, fontSize:'clamp(72px,15vw,120px)', color:C.amber100, letterSpacing:'-0.06em', lineHeight:1, marginBottom:-16 }}>404</div>
        <h1 style={{ fontFamily:font.head, fontWeight:800, fontSize:'clamp(24px,4vw,36px)', letterSpacing:'-0.04em', color:C.ink, marginBottom:14 }}>
          This note doesn't exist.
        </h1>
        <p style={{ fontSize:16, color:C.muted, lineHeight:1.7, fontFamily:font.body, marginBottom:36 }}>
          The page you're looking for has been moved, deleted, or never existed. Let's get you back to your notes.
        </p>
        <div style={{ display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap' }}>
          <a href="/dashboard" style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'12px 24px', borderRadius:12, background:`linear-gradient(135deg,${C.amber300},${C.amber400})`, color:C.white, fontWeight:700, fontSize:15, textDecoration:'none', fontFamily:font.body }}>
            Go to my notes
          </a>
          <a href="/" style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'12px 20px', borderRadius:12, border:`1.5px solid ${C.border}`, color:C.muted, fontWeight:600, fontSize:15, textDecoration:'none', fontFamily:font.body }}>
            <ArrowLeft size={15}/> Back to home
          </a>
        </div>
      </div>
    </div>
  </>
);

export default NotFound;
